export const quotes_goods_displayed_columns_locale = {
  description: "Description",
  grossWeight: "Gross weight",
  numberOfCollis: "Nr. of collis (outer)"
};
